import React from "react";
import { string, bool } from "prop-types";

import TagStorySearch from "../../../molecules/TagStorySearch";
import DfpAd from "../../../dfp-ad";

import { validURL } from "../../../utils/utils";

import "./organism3.m.css";

const Organism3 = ({
  className = "",
  isSectionComponent,
  widgetUrl = null,
  widgetHeight = null,
  collectionSlug,
  adSlotId = "",
  lang,
  bannerClick,
  bannerImg,
}) => {
  return (
    <div styleName="base" className={className}>
      <div styleName="ad-slot">
        <DfpAd
          adtype={
            isSectionComponent
              ? lang === "en"
                ? "EnPalo_ROS_336x280_R1"
                : "News_336x280_R1"
              : lang === "en"
              ? "EnPalo_HP_300x250_R3"
              : "Home_336x280_R3"
          }
          collectionSlug={collectionSlug}
          slotId={adSlotId}
        />
      </div>
      {!isSectionComponent || (widgetUrl && String(widgetUrl).toLocaleLowerCase().includes("localsearch")) ? (
        <TagStorySearch className="tag-story" />
      ) : (
        widgetUrl &&
        validURL(widgetUrl) && (
          <div styleName="widget-wrapper">
            <iframe
              title="six stories 1 ad with tag search "
              src={widgetUrl}
              styleName="widget-iframe"
              style={widgetHeight ? { height: `${widgetHeight}px` } : {}}
            ></iframe>
          </div>
        )
      )}

      {bannerClick && bannerImg && (
        <a aria-label="special ads" target="_blank" rel="noreferrer" styleName="special_ad_wrapper" href={bannerClick}>
          <img src={bannerImg} alt="special ads" />
        </a>
      )}
    </div>
  );
};

Organism3.propTypes = {
  className: string,
  isSectionComponent: bool,
  widgetUrl: string,
  widgetHeight: string,
  collectionSlug: string,
  adSlotId: string,
  lang: string,
  bannerClick: string,
  bannerImg: string,
};

export default Organism3;
